import React, { useEffect, useState } from "react";
import "./EmployeeServicesModal.css";
import "../modal-base.css";
import DynamicTable from "../../Table/Table";
import {
    assignEmployeeServices,
    getEmployeeServices,
    removeEmployeeService,
} from "../../../services/employee-services";
import { useAuth } from "../../../context/AuthContext";

export default function EmployeeServicesModal({ employee, setShowModal, branches }) {
    const { institution } = useAuth();
    const [services, setServices] = useState([]);
    const [allBranchServices, setAllBranchServices] = useState([]);
    const [selectedServiceId, setSelectedServiceId] = useState("");
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");

    useEffect(() => {
        loadServices();
    }, [employee.id]);

    const loadServices = async () => {
        setLoading(true);
        try {
            const serviceRes = await getEmployeeServices(employee.id);
            setServices(serviceRes.data || []);

            // ✅ خذ الخدمات من الفرع الصحيح
            const branch = branches.find(b => b.id === Number(employee.branchId));
            setAllBranchServices(branch?.services || []);
        } catch (err) {
            console.error("فشل في تحميل البيانات", err);
        }
        setLoading(false);
    };
const handleAdd = async (setRecentlyAddedId) => {
  if (!selectedServiceId) return alert("يرجى اختيار خدمة أولاً");

  // 1. جهّز القائمة المحدثة
  const currentServiceIds = services.map((s) => s.id);
  const updatedServiceIds = [...currentServiceIds, selectedServiceId];

  // 2. أرسلهم للباكند
  await assignEmployeeServices(employee.id, updatedServiceIds, token);

  // ✅ 3. أعد تحميل البيانات من الباكند مباشرة
  await loadServices(); // ← هاي اللي كانت في useEffect

  // 4. (اختياري) علّم الصف المضاف
  setRecentlyAddedId(selectedServiceId);

  // 5. فضّي الاختيار
  setSelectedServiceId("");
};


    const handleDelete = async (id) => {
        await removeEmployeeService(employee.id, id, token);
        setServices((prev) => prev.filter((s) => s.id !== id));
    };

    const unassignedServices = allBranchServices.filter(
        (s) => !services.some((ss) => ss.id === s.id)
    );

    return (
        <div className="modal-backdrop">
            <div className="modal-box" style={{ width: "90%", maxWidth: "700px", direction: "rtl" }}>
                <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                <div className="modal-title">إدارة خدمات الموظف: {employee.name}</div>

                <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
                    <select
                        value={selectedServiceId}
                        onChange={(e) => setSelectedServiceId(e.target.value)}
                        className="service-dropdown"
                        style={{
                            flex: 1,
                            padding: "10px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            fontSize: "15px",
                        }}
                    >
                        <option value="">اختر خدمة لإسنادها</option>
                        {unassignedServices.map((s) => (
                            <option key={s.id} value={s.id}>
                                {s.name}
                            </option>
                        ))}
                    </select>

                    <button
                        onClick={() => handleAdd(() => { })}
                        className="btn filled"
                        style={{
                            padding: "10px 16px",
                            borderRadius: "8px",
                            fontSize: "15px",
                            backgroundColor: "var(--clr-primary)",
                            color: "#fff",
                            border: "none",
                            cursor: selectedServiceId ? "pointer" : "not-allowed",
                            opacity: selectedServiceId ? 1 : 0.6,
                        }}
                        disabled={!selectedServiceId}
                    >
                        إضافة
                    </button>
                </div>

                <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <DynamicTable
                        data={services}
                        columns={[{ key: "name", label: "اسم الخدمة" }]}
                        onAdd={null}
                        onDelete={handleDelete}
                        loading={loading}
                        showDetailsColumn={false}
                    />
                </div>

            </div>
        </div>
    );
}
